import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BackButton = ({ to, label, className = '' }) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    // Use translation if label not provided
    const buttonLabel = label || t('sharedReport.back', 'عودة');

    // Determine arrow direction based on language
    const arrowIcon = i18n.dir() === 'rtl' ? 'fa-arrow-right' : 'fa-arrow-left';

    const handleClick = () => {
        if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            onClick={handleClick}
            className={`btn btn-light btn-sm ${className}`}
            style={{ borderRadius: '8px' }}
        >
            <i className={`fas ${arrowIcon} me-2`}></i>
            {buttonLabel}
        </button>
    );
};

export default BackButton;
